import { useMutation } from '@apollo/client';
import { DEACTIVATE_DOCUMENT } from '../../graphql/mutations';

interface DeactivateDocumentResponse {
  uuid: string;
}

interface DeactivateDocumentData {
  deactivateDocument: DeactivateDocumentResponse;
}

interface DeactivateDocumentVars {
  studyId?: string;
  carePlanId?: string;
  careActivityId?: string;
  typeId: string;
}

export const useDeactivateDocument = (): {
  deactivateDocument: (
    variables: DeactivateDocumentVars,
  ) => Promise<{ data?: DeactivateDocumentData }>;
  loading: boolean;
  error?: any;
} => {
  const [deactivateDocumentMutation, { loading, error }] = useMutation<
    DeactivateDocumentData,
    DeactivateDocumentVars
  >(DEACTIVATE_DOCUMENT);

  const deactivateDocument = (inputVars: DeactivateDocumentVars) => {
    const variables: DeactivateDocumentVars = { typeId: inputVars.typeId };

    if (inputVars.carePlanId && inputVars.careActivityId) {
      variables.carePlanId = inputVars.carePlanId;
      variables.careActivityId = inputVars.careActivityId;
    } else if (inputVars.studyId) {
      variables.studyId = inputVars.studyId;
    }

    return deactivateDocumentMutation({ variables });
  };

  return {
    deactivateDocument,
    loading,
    error,
  };
};
